module.exports = __webpack_public_path__ + "4b4aabd0c4ace597e91c319b1a13de2b.png";